/**
 * Toggle and Date/time sidebar component
 * @param {{sideBarOpen: boolean, setSideBarOpen:function}} param0
 * @returns
 */
export default function SideBarTimeAndToggle({ sideBarOpen, setSideBarOpen }) {
  const dateString = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  const timeString = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  return (
    <div className="flex items-center justify-between mx-auto mt-5 space-x-3">
      {sideBarOpen && (
        <p className="font-bold text-white uppercase truncate text-segments-13px text-opacity-30">
          {timeString} | {dateString}
        </p>
      )}
      {/* Turned OFF for V2.1 Release due to multi-menu responsivness */}
      {/* <button
        aria-label="open-close sidebar"
        className="focus:outline-none"
        onClick={() => {
          setSideBarOpen(!sideBarOpen);
        }}
      >
        <div className={`transform ${!sideBarOpen && 'rotate-180'}`}>
          <HideMenuIcon />
        </div>
      </button> */}
    </div>
  );
}
